import moment from 'moment';
import angular from 'angular';
import {getPreviousWeekday} from "../app";
import {activeFilterCount, applyFilters, matchesFilters} from '../charts/boardFilters.js';
import {TRADE_FILTERS} from '../charts/boardFilterCategories.js';
import {showBoardFilters} from './board-filters-dialog';

export default function MemberTradesCtrl($scope, TradesService, $state, $stateParams, $anchorScroll, $mdMedia, $mdDialog, observeOnScope, businessDays) {

  $scope.noItems = false;
  $scope.refused = null;   // the backend's message when it won't show this login the board
  $scope.meta = TradesService.meta();
  $scope.state = $state;
  $scope.currentGroup = null;
  $scope.report = $stateParams.report;
  $scope.mdMedia = $mdMedia;

  $scope.minDate = new Date(2024, 0, 1); // minimum selectable date - January 1, 2024
  $scope.maxDate = new Date(); // maximum selectable date - current date

  var validDays = [];

  businessDays.subscribe(d => validDays = d);

  $scope.filterDays = function async (date) {

    if (validDays.length < 1) {
      const day = date.getDay();
      return day !== 0 && day !== 6; // Disable if it's Sunday (0) or Saturday (6)
    }

    // Use the valid business days from the server
    const day = moment(date).format('YYYY-MM-DD 00:00:00');
    return validDays.includes(day);
  };

  let dSubscription = observeOnScope($scope, 'meta.reportDate')
    .debounce(100)
    .filter(() => $stateParams.report !== 'current')
    .filter(({newValue}) => newValue)
    .map(({newValue, oldValue}) => ({
      newValue: moment(newValue).format('YYYY-MM-DD'),
      oldValue: oldValue && moment(oldValue).format('YYYY-MM-DD')
    }))
    .filter(({newValue, oldValue}) => newValue !== oldValue)
    .subscribe(({newValue}) => {

      let r = newValue;

      if ($stateParams.report === 'report33') {
        return;
      }

      if (newValue === moment().format('YYYY-MM-DD')) {
        r = 'current';
      } else if (newValue === moment(getPreviousWeekday()).format('YYYY-MM-DD')) {
        r = 'report11';
      }

      $state.go('member.trades', {report: r});
    });

  $scope.$on('$destroy', () => dSubscription.dispose());

  var oldTrades;

  // A login the backend won't show the board to (no trading access): its message where the board
  // would be, in place of rows another report left in the service.
  var tradeLoadSubscription = TradesService.load($scope.report, function (message) {
    $scope.$applyAsync(function () {
      $scope.refused = message;
      $scope.trades = [];
      $scope.noItems = false;
    });
  });

  var tradesSubscription = TradesService.subject
    .safeApply($scope, function (trades) {

      oldTrades = $scope.trades;

      $scope.trades = oldTrades ?
        trades.filter(function (trade) {
          trade.new = oldTrades.filter(function (oldTrade) {
            return oldTrade.TradeNo == trade.TradeNo;
          }).length == 0;
          return trade;
        })
        : trades;

      $scope.noItems = $scope.trades.length < 1;
    })
    .subscribe(function () {
      if ($state.params.id) {
        $anchorScroll('trade' + $state.params.id);
      }
    });

  $scope.trackBy = function (group) {
    return group[0].EggType + group[0].EggColor + group[0].EggClass;
  };

  $scope.filterYours = false;

  $scope.showDivider = function (index) {
    var list = $scope.displayedTrades;
    if (!list || index >= list.length - 1) {
      return false;
    }
    // Only show divider at the first transition from one ba value to another
    if (list[index].ba === list[index + 1].ba) {
      return false;
    }
    for (var i = 0; i < index; i++) {
      if (list[i].ba !== list[i + 1].ba) {
        return false; // a transition already occurred earlier
      }
    }
    return true;
  };

  $scope.showYours = function (array) {

    if (!array) {
      return;
    }

    var buyerCount = 0;
    var sellerCount = 0;
    var name = '';
    for (var i = 0; i < array.length; ++i) {
      if (array[i].BuyerID) {
        buyerCount++;
        name = array[i].BuyerID;
      }

      if (array[i].SellerID) {
        sellerCount++;
        name = array[i].SellerID;
      }

    }
    return ' You Bought: ' + buyerCount + ', Sold: ' + sellerCount;
  };

  $scope.toggleFilterYours = function () {
    $scope.filterYours = !$scope.filterYours;
  };

  $scope.yoursFilter = function (trade) {
    if (!$scope.filterYours) {
      return true;
    }
    return trade.BuyerID || trade.SellerID;
  };

  // Filters (the Filters dialog): they narrow the list on top of Yours.
  $scope.filters = {};
  $scope.filterCount = 0;

  function setFilters(selection, source) {
    $scope.filters = selection;
    $scope.filterCount = activeFilterCount(selection);
    if (source) {
      TradesService.logFilters(selection, applyFilters($scope.trades || [], selection, TRADE_FILTERS).length, source);
    }
  }

  $scope.openFilters = function (ev) {
    // The dialog offers the board's rows, yours only when that is on.
    showBoardFilters($mdDialog, $mdMedia, ev, {
      rows: ($scope.trades || []).filter($scope.yoursFilter),
      categories: TRADE_FILTERS,
      selection: $scope.filters
    }).then(selection => setFilters(selection, 'dialog'), angular.noop);
  };

  $scope.clearFilters = function () {
    setFilters({}, 'clear');
  };

  // Arriving from a colour of the home page's flow chart, the board opens filtered to it.
  const openingFilters = TradesService.takeOpeningFilters();
  setFilters(openingFilters || {}, openingFilters ? 'home_chart' : null);

  /** The list's row filter (ng-repeat ... | filter:boardFilter). */
  $scope.boardFilter = function (trade) {
    return matchesFilters(trade, $scope.filters, TRADE_FILTERS);
  };

  // "Showing N of M": what the list shows, of the whole board.
  $scope.$watchGroup(['filters', 'filterYours', 'trades'], function () {
    var rows = $scope.trades || [];
    $scope.boardCount = rows.length;
    $scope.shownCount = applyFilters(rows.filter($scope.yoursFilter), $scope.filters, TRADE_FILTERS).length;
  });

  $scope.goToMemberTrade = function (trade, $event) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    if (!trade._tradeno) {
      return;
    }
    var stateName = trade.BuyerID ? 'member.account.payables.trade' : 'member.account.receivables.trade';
    $state.go(stateName, {id: trade._tradeno});
  };

  $scope.doRefresh = function () {
    TradesService.reload().then(function () {
      $scope.$broadcast('scroll.refreshComplete');
    });
  };

  $scope.$on('$destroy', function () {
    tradesSubscription.dispose();
    tradeLoadSubscription.dispose();
  });

  //Column sorting
  $scope.sortField = null;
  $scope.sortReverse = false;
  $scope.sortKey = null;

  var numericSort = function (prop) {
    return function (item) {
      return parseFloat(item[prop]) || 0;
    };
  };

  var numericFields = {
    'SalePrice': numericSort('SalePrice'),
    'DockPrice': numericSort('DockPrice'),
    'Market': numericSort('Market'),
    'Qty': numericSort('Qty')
  };

  $scope.sortBy = function (field) {
    var key = field.toString();
    if ($scope.sortKey === key) {
      if ($scope.sortReverse) {
        $scope.sortField = null;
        $scope.sortReverse = false;
        $scope.sortKey = null;
      } else {
        $scope.sortReverse = true;
      }
    } else {
      // Use numeric sort function if available for single fields
      if (typeof field === 'string' && numericFields[field]) {
        $scope.sortField = numericFields[field];
      } else if (Array.isArray(field) && field.length > 0 && numericFields[field[0]]) {
        $scope.sortField = numericFields[field[0]];
      } else {
        $scope.sortField = field;
      }
      $scope.sortReverse = false;
      $scope.sortKey = key;
    }
  };

  $scope.hasDisplayValue = function(attr) {
    if (!attr) {return false;}
    if (!attr.value) {return false;}
    switch (attr.type) {
      case 'boolean':     return attr.value === true || attr.value === false;
      case 'multiselect': return Array.isArray(attr.value) && attr.value.length > 0;
      default:            return attr.value !== null && attr.value !== undefined && attr.value !== '';
    }
  };

  $scope.displayValue = function(attr) {
    if (!attr) {return '';}
    switch (attr.type) {
      case 'boolean':     return attr.value ? 'Yes' : 'No';
      case 'multiselect': return (attr.value || []).join(', ') + (attr.unit ? ` ${attr.unit}` : '');
      default:            return attr.value + (attr.unit ? ` ${attr.unit}` : '');
    }
  };

  $scope.displayAbbreviation= function(attr) {
    if (!attr) {return '';}
    switch (attr.type) {
      case 'select':     return attr.value || attr.abbreviation;
      default:           return attr.abbreviation;
    }
  };

}
